module.exports = __webpack_public_path__ + "static/media/blog-3.6bc8da9a.jpg";